import { useSelector } from 'react-redux';
import { personalizedSidebarBannerEnabled } from 'reactApp/appHelpers/featuresHelpers/features/personalization';
import { useFamilyShowFeaturesHook } from 'reactApp/hooks/useFamilyShowHook';
import { usePredictedSubscription } from 'reactApp/hooks/usePersonalizationPromoInformation';
import { BillingDataSelectors } from 'reactApp/modules/billingData/billingData.selectors';
import { BillingDataSubscriptionInfoStatus } from 'reactApp/modules/billingData/billingData.types';
import { BillingPersonalizationSelectors } from 'reactApp/modules/billingPersonalization/billingPersonalization.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';

const isValidPeriodForPersonalization = (period?: string): boolean => {
    return period === '1m' || period === '1y';
};

export const usePersonalizationBanner = () => {
    const { tariffId: predictedSubscriptionId } = usePredictedSubscription();

    const sortedSubscriptions = useSelector(BillingDataSelectors.sortSubscriptionsBySpace);
    const trialSubscription = useSelector(BillingDataSelectors.getTrialSubscription);
    const currentSubscription = sortedSubscriptions?.[0];

    const { isLoaded: isPersonalizationLoaded } = useSelector(BillingPersonalizationSelectors.getLoadingState);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isFamilyUser = useFamilyShowFeaturesHook();

    const isValidPeriod = isValidPeriodForPersonalization(currentSubscription?.productPeriod);
    const isTrial = trialSubscription || currentSubscription?.isTrial;
    const isGrace = currentSubscription?.status === BillingDataSubscriptionInfoStatus.GRACE;

    return (
        personalizedSidebarBannerEnabled &&
        isPersonalizationLoaded &&
        isPaidUser &&
        !isCorpUser &&
        !isBizUser &&
        !!predictedSubscriptionId &&
        isValidPeriod &&
        !isTrial &&
        !isGrace &&
        !isFamilyUser
    );
};
